import * as FullStory from '@fullstory/browser'

const defaultOptions = {
  debug: false,
  host: 'fullstory.com',
  namespace: 'FS',
  orgId: 'AH73K',
  recordOnlyThisIFrame: true,
  script: 'edge.fullstory.com/s/fs.js'
}

const FullStoryAnalytics = {...FullStory}

FullStoryAnalytics.init = (options, callback) => {
  if (typeof window === 'undefined') return
  const newOptions = {...defaultOptions, ...options}
  FullStory.init(newOptions, callback)
}

export {defaultOptions}
export default FullStoryAnalytics
